import { stripPathLocale } from '../../../../../../../shared/common/localeShared';

export const StreamMasthead = {
  RWF_RECAP: 'rwf-recap',
  VENOMOUS_ABYSS_RWF: 'venomous-abyss-rwf',
  SPOREFALL_RWF: 'sporefall-rwf',
  TIER_MN1_RWF: 'tier-mn1-rwf',
  ARKHERON: 'arkheron',
  AWC: 'awc',
  MDI: 'mdi'
} as const;

export type TStreamMasthead = (typeof StreamMasthead)[keyof typeof StreamMasthead];

export const RwfMastheadMode = {
  LIVE: 'live',
  RECAP: 'recap'
} as const;

export const RWF_MASTHEAD_MODE_PARAM = 'rwf_masthead_mode';

export type TRwfMastheadConfig = {
  featureFlag: string;
  liveMasthead: TStreamMasthead;
  raidSlug: string;
};

const RWF_MASTHEADS: TRwfMastheadConfig[] = [
  {
    featureFlag: 'rwf_the_venomous_abyss_masthead',
    liveMasthead: StreamMasthead.VENOMOUS_ABYSS_RWF,
    raidSlug: 'the-venomous-abyss'
  },
  {
    featureFlag: 'rwf_sporefall_masthead',
    liveMasthead: StreamMasthead.SPOREFALL_RWF,
    raidSlug: 'sporefall'
  },
  {
    featureFlag: 'rwf_tier_mn_1_masthead',
    liveMasthead: StreamMasthead.TIER_MN1_RWF,
    raidSlug: 'tier-mn-1'
  }
];

type TStreamMastheadSelectionProps = {
  currentFeatures?: Record<string, any>;
  streamers?: Array<{
    stream?: {
      game_id?: string;
      name?: string;
    };
  }>;
};

const ARKHERON_GAME_ID = '1295872446';

export function selectActiveRwfMasthead(currentFeatures: Record<string, any> = {}): TRwfMastheadConfig | null {
  return RWF_MASTHEADS.find(({ featureFlag }) => currentFeatures[featureFlag]) || null;
}

export function isRwfRecapMastheadSelected(currentFeatures: Record<string, any> = {}): boolean {
  return (
    currentFeatures.params?.[RWF_MASTHEAD_MODE_PARAM] === RwfMastheadMode.RECAP &&
    selectActiveRwfMasthead(currentFeatures) !== null
  );
}

export function selectStreamMasthead(props: TStreamMastheadSelectionProps, pathname: string): TStreamMasthead | null {
  const currentFeatures = props.currentFeatures || {};
  const primaryStream = props.streamers?.[0]?.stream;
  const rwfMasthead = selectActiveRwfMasthead(currentFeatures);

  if (rwfMasthead) {
    return isRwfRecapMastheadSelected(currentFeatures) ? StreamMasthead.RWF_RECAP : rwfMasthead.liveMasthead;
  }

  const localizedPath = stripPathLocale(pathname);
  if ((localizedPath === '' || localizedPath === '/') && primaryStream?.game_id === ARKHERON_GAME_ID) {
    return StreamMasthead.ARKHERON;
  }

  const isWarcraftStream = primaryStream?.name?.toLowerCase() === 'warcraft';
  if (currentFeatures.stream_feature_warcraft_awc && isWarcraftStream) {
    return StreamMasthead.AWC;
  }

  if (currentFeatures.stream_feature_warcraftmdi && isWarcraftStream) {
    return StreamMasthead.MDI;
  }

  return null;
}
